export default function ({ route, redirect, store }) {
  //初始化重定向
  if (route.path === '/operators') {
    return redirect( '/speedtest-deployment');
  }

}
